import React, {Component} from 'react';
import SearchingTitleComponent from './SearchingTitleComponent';
import ReactDOM from 'react-dom';
import { Badge, Col, Row } from 'reactstrap';
import { GetListAttempt_ACTION, GetMultipleListAttempt_ACTION } from '../Actions/LogisticActions';
import {connect} from 'react-redux'
import { Routes } from '../Services/API';
import ModalComponent from './ModalComponent';
import ImageTreeNode from './ImageTreeNode';
import {Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle} from 'react-shapes';
import Slider from '@material-ui/core/Slider';
import NameComponent from './NameComponent';

class MultipleChoiceQuestionAnswerViewComponent extends Component {
    constructor(props){
        super(props)

        this.state = {
           
            Offset:0
        }


    }

    render(){
        console.log(this)
        return(
            <div style = {{flexDirection:'column', display:'flex', alignContent:'center', alignItems:'center', width: '100%'}}> 
            <img 
                style = {{width: this.props.Width, height:this.props.Width, objectFit:'contain'}}
                src = {this.props.Question.Base_ImageURL}
            />

           
           
        </div>
        )
    }

    
}

function MapStateToProps(state) {
    return {

    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        
  }
}
  
export default connect(MapStateToProps, MapDispatchToProps)(MultipleChoiceQuestionAnswerViewComponent)